import React from "react";
import { useSelector } from "react-redux";
import { removeCurrencySign } from "../../../Constants/utils";
import { getCustomerCount } from "../../../Redux/features/Dashboard/Charts/customerCountSlice";
import { priceFormate } from "../../../hooks/priceFormate";
import { CommonChart } from "./CommonChart";

export const CustomerCountChart = ({
  merchantId,
  activeType,
  presentDate,
  customerCountChartInView,
  customerCountChartRef,
  selectedOutletIds = [],
}) => {
  const customerCountChart = useSelector((state) => state.customerCountChart);
  const chartKey = "customerCountChart";

  return (
    <>
      <CommonChart
        componentRef={customerCountChartRef}
        activeType={activeType}
        formatFunction={removeCurrencySign}
        presentDate={presentDate}
        sliceCallback={getCustomerCount}
        yAxisText={"Unique Customers"}
        reduxState={customerCountChart}
        reduxStateKey={"customerCountData"}
        reduxStateTotalKey={"totalCustomerCount"}
        valueKey={"total_customer"}
        chartKey={chartKey}
        merchantId={merchantId}
        chartInView={customerCountChartInView}
        title={"Unique Customers"}
        totalValueFunction={priceFormate}
        selectedOutletIds={selectedOutletIds}
      />
    </>
  );
};
